class LanguageTracking  {
    constructor() {
        this.currentLanguage = window.Shopify.locale || '';
        this.currentCountry = window.Shopify.country || '';
        this.cookieKey = '_tracking_current_language';
    }

    trackLang() {
        const utils = new Utils();
        const localizationData = { country: this.currentCountry, language: this.currentLanguage }
        utils.setCookie(this.cookieKey, JSON.stringify(localizationData), 10);
    }
}

new LanguageTracking().trackLang();